export const isMainPlatform =
  window.location.host === process.iblsEnv.IBLS_MAIN_PLATFORM
